import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { DataTable } from './DataTable';
import { format } from 'date-fns';
import { useDeploymentTimeline } from '@/hooks/useDeploymentTimeline';

interface DatewiseDeploymentTableProps {
  catalogTasks: any[];
  incidents: any[];
  linkedIncidents?: any[];
  dateRange?: {
    from: Date;
    to: Date;
  };
}

export function DatewiseDeploymentTable({ 
  catalogTasks, 
  incidents, 
  linkedIncidents = [],
  dateRange 
}: DatewiseDeploymentTableProps) {
  console.log('DatewiseDeploymentTable dateRange:', {
    from: dateRange?.from ? format(dateRange.from, 'yyyy-MM-dd') : 'none',
    to: dateRange?.to ? format(dateRange.to, 'yyyy-MM-dd') : 'none'
  });

  // Use the shared deployment timeline hook
  const excelData = React.useMemo(() => ({
    'Catalog Tasks': catalogTasks || [],
    'Incidents': incidents || []
  }), [catalogTasks, incidents]);

  // Get data from the timeline hook to ensure consistency
  const timelineDataByApi = useDeploymentTimeline(excelData, dateRange);

  // Process timeline data for the table view
  const datewiseData = React.useMemo(() => {
    const result: any[] = [];

    timelineDataByApi.forEach((data, apiName) => {
      // Find days with deployments
      data.filter(day => day.deployments > 0).forEach(day => {
        if (day.deploymentDetails?.length > 0) {
          day.deploymentDetails.forEach((deployment: any) => {
            // Count incidents that occurred after this deployment date
            const incidentCount = day.incidentDetails?.length || 0;
            
            result.push({
              deploymentDate: deployment.date,
              formattedDate: format(new Date(deployment.date), 'MMM d, yyyy'),
              apiName: deployment.originalApiName || apiName,
              taskNumber: deployment.taskNumber,
              postDeploymentIncidents: incidentCount
            });
          });
        }
      });
    });

    // Sort by date, most recent first
    return result.sort((a, b) => 
      new Date(b.deploymentDate).getTime() - new Date(a.deploymentDate).getTime()
    );
  }, [timelineDataByApi]);

  console.log('Final datewiseData:', datewiseData);

  const columns = [
    {
      key: "date",
      header: "Deployment Date",
      cell: (item: any) => (
        <div className="text-sm font-medium">
          {item.formattedDate}
        </div>
      ),
    },
    {
      key: "apiName",
      header: "API Deployed",
      cell: (item: any) => (
        <div className="text-sm">
          {item.apiName}
        </div>
      ),
    },
    {
      key: "taskNumber",
      header: "Task Number",
      cell: (item: any) => (
        <div className="text-sm">
          {item.taskNumber}
        </div>
      ),
    },
    {
      key: "postDeploymentIncidents",
      header: "Post-Deployment Incidents",
      cell: (item: any) => (
        <Badge variant={item.postDeploymentIncidents > 0 ? "destructive" : "outline"}>
          {item.postDeploymentIncidents}
        </Badge>
      ),
    },
  ];

  return (
    <Card>
      {/* <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span>Post-Deployment Incidents by API</span>
          <div className="flex gap-2">
            <Badge variant="outline">
              {datewiseData.length} deployments
            </Badge>
            <Badge variant="outline">
              {incidents.length} linked incidents
            </Badge>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <DataTable 
          data={datewiseData} 
          columns={columns} 
        />
      </CardContent> */}
    </Card>
  );
}
